import React from 'react';
import { Container, Box, Typography, Breadcrumbs, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useOrganization } from '../../context/OrganizationContext';
import { ActivityFeed } from '../../components/activity';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';

/**
 * OrganizationActivities Page
 *
 * Displays full activity feed for the organization with filters and pagination
 */
const OrganizationActivities = () => {
  const navigate = useNavigate();
  const { currentOrganization, loading } = useOrganization();

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  if (!currentOrganization) {
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Typography variant="h5" color="error">
          No organization selected
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: { xs: 2, sm: 3, md: 4 }, px: { xs: 1, sm: 2, md: 3 } }}>
      {/* Breadcrumbs */}
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{ mb: { xs: 2, sm: 3 }, fontSize: { xs: '0.875rem', sm: '1rem' } }}
        aria-label="breadcrumb"
      >
        <Link
          underline="hover"
          sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
          color="inherit"
          onClick={() => navigate('/dashboard')}
        >
          <HomeIcon sx={{ mr: 0.5, fontSize: { xs: '1rem', sm: 'inherit' } }} />
          <span style={{ fontSize: 'inherit' }}>Dashboard</span>
        </Link>
        <Typography color="text.primary" sx={{ fontSize: 'inherit' }}>Activities</Typography>
      </Breadcrumbs>

      {/* Page Header */}
      <Box sx={{ mb: { xs: 2, sm: 3 } }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{ fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2.125rem' } }}
        >
          Activity Log
        </Typography>
        <Typography
          variant="body1"
          color="textSecondary"
          sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}
        >
          View all activities across your organization including fleet management, team changes, and settings updates.
        </Typography>
      </Box>

      {/* Activity Feed */}
      <ActivityFeed
        orgId={currentOrganization?.organizationUuid}
        title="All Activities"
        showFilters={true}
        showPagination={true}
        limit={25}
        height={{ xs: 'calc(100vh - 180px)', sm: 'calc(100vh - 200px)', md: 'calc(100vh - 220px)' }}
      />
    </Container>
  );
};

export default OrganizationActivities;
